// extracted by mini-css-extract-plugin
export default {"avatar":"AvatarButton_avatar__d5Ma6","avatarIcon":"AvatarButton_avatarIcon__5ftn9","dialog":"AvatarButton_dialog__vN8zv"};